const typingElements = document.querySelectorAll('.typing-element')

typingElements.forEach(element => {
	let i = 0
	let typed = false
	const speed = 50

	// Get the inner HTML content (including any HTML tags)
	const elementContent = element.innerText

	// Check position of the element
	const elementPosition = element.getBoundingClientRect().top
	let windowScrollPosition = window.scrollY + window.innerHeight

	// Function to run the typing effect
	const runTyping = element => {
		if (windowScrollPosition > elementPosition && !typed) {
			typed = true
			element.innerText = '' // Clear the content initially
			let currentContent = '' // Holds the content as it gets typed

			// The function to type one character at a time
			const counterInterval = setInterval(() => {
				currentContent += elementContent.charAt(i)
				element.innerHTML = currentContent // Update the element content
				i++
				if (i >= elementContent.length) {
					clearInterval(counterInterval) // Stop the typing effect when all text is typed
				}
			}, speed)
		}
	}

	runTyping(element)

	// Listen for further scroll events to trigger the typing effect when the element comes into view
	document.addEventListener('scroll', () => {
		windowScrollPosition = window.scrollY + window.innerHeight
		runTyping(element)
	})
})
